import React from 'react';
import TabPanel from '../../components/TabPanel';
import Grid from '@mui/material/Grid';
import { Variable } from '../../types/variable';
import JobVariableSelect from './JobVariableSelect';
import JobVariables from './JobVariables';
import useConfigStyles from '../../components/useConfigStyles';

interface JobVariablesTabPanelProps {
  schoolYear: number | undefined;
  variables: Variable[];
  index: number;
  selectedTab: number;
  editable: boolean;
  onVariablesUpdate?: (variables: Variable[]) => void;
}

function JobVariablesTabPanel({ schoolYear, variables, index, selectedTab, editable, onVariablesUpdate }: JobVariablesTabPanelProps): JSX.Element {
  const classes = useConfigStyles();

  const addVariable = (variable: Variable) => {
    if (!onVariablesUpdate) {
      return;
    }

    const updatedVariables = variables;
    const variableIndex = variables.findIndex((v) => v.Name === variable.Name);
    if (variableIndex >= 0) {
      updatedVariables[variableIndex].Value = variable.Value;
      onVariablesUpdate(updatedVariables);
    } else {
      onVariablesUpdate(updatedVariables.concat(variable));
    }
  };

  const removeVariable = (variable: Variable) => {
    if (!onVariablesUpdate) {
      return;
    }
    const variableIndex = variables.indexOf(variable);
    variables.splice(variableIndex, 1);
    onVariablesUpdate(variables);
  };

  return (
    <TabPanel selectedValue={selectedTab} index={index} className={classes.container}>
      {editable && (
        <Grid item className={classes.input} md={6}>
          <JobVariableSelect variables={variables} addVariable={addVariable} schoolYear={schoolYear} />
        </Grid>
      )}
      <Grid item className={classes.input} md={6}>
        <JobVariables variables={variables} removeVariable={removeVariable} editable={editable} />
      </Grid>
    </TabPanel>
  );
}

JobVariablesTabPanel.defaultProps = {
  onVariablesUpdate: () => {},
};

export default JobVariablesTabPanel;
